const initialState = {
    data: {
        memberId:'N-N',
        citizenName: 'N-N',
        citizenSince: 'N-N',
        citizensNum: 'N-N',
        budget: 'N-N',
        proposalsNum: '0',
        balanceIn: 'N-N',
        balanceInToken: 'N-N',
        activePage: '1',
        proposalsPassed: false,
        proposals: [],
        citizensPage: {
            citizensPassed: false,
            activePage: '1',
            citizens: []
        }
    }
}

const cityReducer = (state = initialState, action) => {
    if (action.type === 'IS_CITIZEN'){
        return Object.assign({}, state, {
            data: {
                memberId: action.payload.memberId,
                citizenName: action.payload.citizenName,
                citizenSince: action.payload.citizenSince,
                citizensNum: action.payload.citizensNum,
                budget: action.payload.budget,
                proposalsNum: action.payload.proposalsNum,
                balanceIn: action.payload.balanceIn,
                balanceInToken: action.payload.balanceInToken,
                activePage: state.data.activePage,
                proposalsPassed: false,
                proposals: state.data.proposals,
                citizensPage: state.data.citizensPage
            }
        })
    }
  
    if (action.type === 'ADD_PROPOSALS'){
        return Object.assign({}, state, {
            data: {
                memberId:state.data.memberId,
                citizenName: state.data.citizenName,
                citizenSince: state.data.citizenSince,
                citizensNum: state.data.citizensNum,
                budget: state.data.budget,
                proposalsNum: state.data.proposalsNum,
                balanceIn: state.data.balanceIn,
                balanceInToken: state.data.balanceInToken,
                activePage: action.payload.activePage,
                proposalsPassed: true,
                proposals: action.payload.proposals,
                citizensPage: state.data.citizensPage
            }
        })
    }
  
    if (action.type === 'SET_NEW_PROPOSAL'){
        return Object.assign({}, state, {
            data: {
                memberId:action.payload.memberId,
                citizenName: state.data.citizenName,
                citizenSince: state.data.citizenSince,
                citizensNum: state.data.citizensNum,
                budget: state.data.budget,
                proposalsNum: state.data.proposalsNum,
                balanceIn: action.payload.balanceIn,
                balanceInToken: action.payload.balanceInToken,
                proposalsPassed: state.data.proposalsPassed,
                activePage: state.data.activePage,
                proposals: state.data.proposals,
                citizensPage: state.data.citizensPage
            }
        })
    }
  
    if (action.type === 'SET_PAY_TAX'){
        return Object.assign({}, state, {
            data: {
                memberId:action.payload.memberId,
                citizenName: state.data.citizenName,
                citizenSince: state.data.citizenSince,
                citizensNum: state.data.citizensNum,
                budget: state.data.budget,
                proposalsNum: state.data.proposalsNum,
                balanceIn: action.payload.balanceIn,
                balanceInToken: state.data.balanceInToken,
                proposalsPassed: state.data.proposalsPassed,
                activePage: state.data.activePage,
                proposals: state.data.proposals,
                citizensPage: state.data.citizensPage
            }
        })
    }
  
    if (action.type === 'SET_EDIT_NAME'){
        return Object.assign({}, state, {
            data: {
                memberId:action.payload.memberId,
                citizenName: action.payload.citizenName,
                citizenSince: state.data.citizenSince,
                citizensNum: state.data.citizensNum,
                budget: state.data.budget,
                proposalsNum: state.data.proposalsNum,
                balanceIn: action.payload.balanceIn,
                balanceInToken: state.data.balanceInToken,
                proposalsPassed: state.data.proposalsPassed,
                activePage: state.data.activePage,
                proposals: state.data.proposals,
                citizensPage: state.data.citizensPage
            }
        })
    }

    if (action.type === 'SET_CITIZENS'){
        return Object.assign({}, state, {
            data: {
                memberId:action.payload.memberId,
                citizenName: state.data.citizenName,
                citizenSince: state.data.citizenSince,
                citizensNum: action.payload.citizensNum,
                budget: state.data.budget,
                proposalsNum: state.data.proposalsNum,
                balanceIn: action.payload.balanceIn,
                balanceInToken: state.data.balanceInToken,
                proposalsPassed: state.data.proposalsPassed,
                activePage: state.data.activePage,
                proposals: state.data.proposals,
                citizensPage: state.data.citizensPage
            }
        })
    }

    if (action.type === 'ADD_CITIZENS'){
        return Object.assign({}, state, {
            data: {
                memberId:state.data.memberId,
                citizenName: state.data.citizenName,
                citizenSince: state.data.citizenSince,
                citizensNum: state.data.citizensNum,
                budget: state.data.budget,
                proposalsNum: state.data.proposalsNum,
                balanceIn: state.data.balanceIn,
                balanceInToken: state.data.balanceInToken,
                proposalsPassed: state.data.proposalsPassed,
                activePage: state.data.activePage,
                proposals: state.data.proposals,
                citizensPage: {
                    citizensPassed: true,
                    activePage: action.payload.activePage,
                    citizens: action.payload.citizens
                }
            }
        })
    }

    if (action.type === 'CITY_LOGGED_OUT'){
        return Object.assign({}, state, {
            data: {
                memberId:'N-N',
                citizenName: 'N-N',
                citizenSince: 'N-N',
                citizensNum: 'N-N',
                budget: 'N-N',
                proposalsNum: 'N-N',
                balanceIn: 'N-N',
                balanceInToken: 'N-N',
                activePage: '1',
                proposalsPassed: false,
                proposals: [],
                citizensPage: {
                    citizensPassed: false,
                    activePage: '1',
                    citizens: []
                }
            }
        })
    }
  
    return state
}

export default cityReducer


// WEBPACK FOOTER //
// ./src/user/cityReducer.js